export default "__VITE_ASSET__CFB5YaUR__"